<!-- ToolBar  -->
<div class="keyword_toolbar">
  <div class="keyword_toolbar_leftBox">
    @if (canEdit()) {
      <button class="keyword_toolbar_newKeyword" (click)="addNewKeyword()">
        <span class="controlListItem_iconBackground"></span>New Keyword Group
      </button>
    }
    @if (canEdit()) {
      <button class="keyword_toolbar_saveBtn btnPrimary" (click)="saveKeywords()">
        Save Keywords
      </button>
    }
  </div>
</div>

<div class="keyword_container">
  <mat-tab-group
    animationDuration="250ms"
    disableRipple="true"
    (selectedTabChange)="channelChanged($event)"
    >
    @for (channel of availableChannels; track channel) {
      <mat-tab>
        <ng-template mat-tab-label>
          <span id="{{ channel['channel-name'] }} {{ channel['channel-id'] }}">
            @if (channel['channel-id'] !== 0 && channel['channel-id'] !==14) {
              <img class="channelImg" src="../../../assets/img/channel/{{ channel['channel-id'] }}.svg"
                onError="this.onerror=null;this.src='../../../assets/img/channel/placeholder.png';"
                alt="{{ channel.channelName }}" />
              } @else {
                <img class="channelImg" src="../../../assets/img/channel/{{ channel['channel-id'] }}.png"
                  onError="this.onerror=null;this.src='../../../assets/img/channel/placeholder.png';"
                  alt="{{ channel.channelName }}" />
                }
              </span>
            </ng-template>
            <ng-container
              *ngTemplateOutlet="keywordsTemplate; context: { channelId: channel['channel-id'] }"
              >
            </ng-container>
            @if (canEdit() && (channelId !== undefined && keywordsFormGroup?.controls[channelId]?.value.length === 0)) {
              <button
                class="addChannelBtn" (click)="addNewKeyword()">
                New Keyword Group
              </button>
            }
          </mat-tab>
        }
      </mat-tab-group>
    </div>

    <ng-template #keywordsTemplate let-channelId="channelId">
      @if (keywordsConflictMessageFormGroup) {
        <form
          class="keyword_conflict_message_form"
          [formGroup]="keywordsConflictMessageFormGroup"
          >
          @if (keywordsConflictMessageFormGroup?.controls[channelId]?.value) {
            <div
              class="keyword_conflictBox"
              [formGroupName]="channelId"
              >
              <label class="keyword_groupLabel">
                Conflicting Keyword Message:
                <app-cms [cmsData]="buildCMSConditions('keyword', 'conflictingKeyword', channelId, 24)"></app-cms>
              </label>
              <input
                class="keyword_conflictMessage"
                [readonly]="!canEdit()"
                placeholder="Add message"
                formControlName="conflictMessage"
                />
              </div>
            }
          </form>
        }
        @if (keywordsFormGroup) {
          <form
            class="keyword_form"
            [formGroup]="keywordsFormGroup"
            >
            @if (keywordsFormGroup?.controls[channelId]?.value; as keywords) {
              @for (keywordGroup of keywords; track trackByFn(i, keywordGroup); let i = $index) {
                <ng-container
                  [formArrayName]="channelId"
                  >
                  <div class="keyword_group">
                    <div class="keyword_group_row" [formGroupName]="i">
                      <div class="keyword_group_flowStepContainer">
                        <div class="keyword_group_flow">
                          @if (keywordsFormGroup.get(channelId + '.' + i + '.' + 'flowName').invalid) {
                            <div
                              class="errorMsg"
                              >
                              <span class="fa fa-exclamation-circle"></span>
                              {{ getErrorMessage('flow') }}
                            </div>
                          }
                          <div class="keyword-select-container">
                            <label class="keyword_group_label_flow keyword-select-item">Flow: </label>
                            @if (!resetOnDelete) {
                              <mat-select
                                #flowName
                                formControlName="flowName"
                                class="keyword_select keyword-select-item"
                                (ngModelChange)="getSteps(flowName?.value, channelId, i)"
                                >
                                @if (flowMetaData$ | async; as flowMetaData2) {
                                  @for (metaData2 of flowMetaData2; track metaData2) {
                                    <mat-option
                                      [value]="metaData2.flowId"
                                      >
                                      {{ metaData2.directory }}
                                      </mat-option
                                      >
                                  }
                                }
                              </mat-select>
                            }
                          </div>
                        </div>
                        <div class="keyword_group_step">
                          @if (keywordsFormGroup.get(channelId + '.' + i + '.' + 'step').invalid) {
                            <div
                              class="errorMsg"
                              [ngClass]="incorrect"
                              >
                              <span class="fa fa-exclamation-circle"></span>
                              {{ getErrorMessage('step') }}
                            </div>
                          }
                          <div class="keyword-select-container">
                            <label class="keyword_group_label keyword-select-item">Step: </label>
                            @if (!resetOnDelete) {
                              <mat-select
                                class="keyword_select keyword-select-item {{i}}"
                                formControlName="step"
                                (selectionChange)="onStepChange($event, i)">
                                @if (getSteps(flowName?.value, channelId, i)) {
                                  @for (step of getSteps(flowName?.value, channelId, i) | async; track step) {
                                    <mat-option
                                      [value]="step"
                                      >
                                      {{ step }}
                                      </mat-option
                                      >
                                    }
                                  } @else {
                                    <mat-option
                                      [value]="keywordsFormGroup.get(channelId + '.' + i + '.' + 'step').value"
                                      >
                                      {{
                                      keywordsFormGroup.get(channelId + '.' + i + '.' + 'step').value
                                      }}
                                      </mat-option
                                      >
                                      <mat-option>Loading...</mat-option>
                                      @for (number of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]; track number) {
                                        <mat-option
                                        ></mat-option>
                                      }
                                    }
                                  </mat-select>
                                }
                              </div>
                            </div>
                          </div>
                          @if (canEdit()) {
                            <button
                              (click)="removeKeywordGroup(i)"
                              class="keyword_delete svgSprite icon_bin"
                            ></button>
                          }
                        </div>
                        <div id="keywordItem" class="keyword_group_row">
                          <clickatell-chip
                            class="keywordChip keyword-page-chip"
                            [readonly]="!canEdit()"
                            [maxKeywords]="checkMaxKeywords(keywordsFormGroup?.controls[channelId]?.controls[i])"
                            [name]="'keywords'"
                            [parentFormGroup]="keywordsConflictMessageFormGroup"
                            [form]="keywordsFormGroup?.controls[channelId]?.controls[i]"
                            [field]="chipField"
                            [maxLength]="chipField.validators.maxLength"
                            >
                          </clickatell-chip>
                          <!-- <form [formGroup]="keywordsConflictMessageFormGroup" class="keyword_conflictForm">
                          <div class="keyword_conflictBox ">
                            <input class="keyword_conflictMessage" placeholder="Add message" formControlName="keywordConflictMessage" />
                            <label class="keyword_groupLabel">
                              Conflicting Keyword Message:
                            </label>
                          </div>
                        </form> -->
                      </div>
                    </div>
                  </ng-container>
                }
                <!--<span style="border-bottom:red solid 1px;"></span>-->
                @if (channelId !== undefined && keywords.length === 0) {
                  @if (bannerCmsData | async; as cmsData) {
                    <div class="setup-keywords">
                      <div class="setup-keywords-container">
                        <div class="setup-keywords__logo">
                          <img src="../../../assets/img/check-mark.png" alt="Check mark" />
                        </div>
                        <div class="setup-keywords-description">
                          <p class="setup-keywords-description_title">{{ cmsData.title }}</p>
                          <p class="setup-keywords-description_text">
                            {{ cmsData.text?.content?.[0]?.content?.[0]?.value }}
                          </p>
                        </div>
                      </div>
                      <div class="setup-keywords-additional-info">
                        <a
                          target="_blank"
                          href="{{cmsData.linkUrl}}"
                          class="setup-keywords-additional-info__link"
                          >{{ cmsData.linkText }}</a
                          >
                        </div>
                      </div>
                      <div class="keyword_noKeyword">You have no keyword groups set up</div>
                    } @else {
                      <div class="setup-routing">
                        <div class="cmsLoadingIcon">
                          <loading-icon></loading-icon>
                        </div>
                      </div>
                    }
                  }
                } @else {
                  @if (loadError) {
                    <load-error title="Unable to load keywords" (retry)="retryLoad()"></load-error>
                  } @else {
                    <loading-icon></loading-icon>
                  }
                }
              </form>
            } @else {
              @if (loadError) {
                <load-error title="Unable to load keywords" (retry)="retryLoad()"></load-error>
              } @else {
                <loading-icon></loading-icon>
              }
            }
          </ng-template>

          <saving-in-progress [showSavingInProgress]="savingInProgress"></saving-in-progress>

          <saving-in-progress [showSavingInProgress]="savingInProgress"></saving-in-progress>
